import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  category: {},
  categories: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    type: null,
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }, type) => {
    state.category = {
      type,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true

    state.filter.type = type
  },

  edit: ({ state }, category) => {
    state.category = { ...category }
    state.type = 'edit'
  },

  save: ({ state }, category) => {
    const id = category.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/category/${id || ''}`, category)
      .then(_ => {
        store.dispatch('categoryStore/get')
        showSuccess('Categoria salva com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/category?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.categories = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/category/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/category/${id}`)
      .then(_ => {
        store.dispatch('categoryStore/get')
        showSuccess('Categoria excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = {
  getById: state => id => {
    return state.categories.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
